import { get, type RequestOptions } from '@/api/client';
import type { DayKpiItem } from './types';

export interface KpiProviderItem {
  column_id: string;
  name: string;
  production_cents?: number;
  patients?: number;
  ontime_pct?: number;
}

export interface KpiProvidersResponse {
  providers: KpiProviderItem[];
}

export interface KpiTodayResponse {
  kpis: DayKpiItem[];
}

export const kpiApi = {
  getProviders: (locationId: number, date?: string, options?: RequestOptions) =>
    get<KpiProvidersResponse>(
      '/api/kpi/providers',
      {
        location: locationId,
        ...(date ? { date } : {}),
      },
      options,
    ),

  getToday: (locationId: number, date?: string, options?: RequestOptions) =>
    get<KpiTodayResponse>(
      '/api/kpi/today',
      {
        location: locationId,
        ...(date ? { date } : {}),
      },
      options,
    ),
};
